import type { AssetEventCreateDto, AssetEventDto, AssetEventUpdateDto, AssetEventWithNavigationPropertiesDto, GetAssetEventsInput } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class AssetEventService {
  apiName = 'Inventory';

  create = (input: AssetEventCreateDto) =>
    this.restService.request<any, AssetEventDto>({
      method: 'POST',
      url: `/api/inventory/asset-events`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/asset-events/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, AssetEventDto>({
      method: 'GET',
      url: `/api/inventory/asset-events/${id}`,
    },
    { apiName: this.apiName });

  getAssetLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: `/api/inventory/asset-events/asset-lookup`,
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getEventTypeLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: `/api/inventory/asset-events/event-type-lookup`,
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getList = (input: GetAssetEventsInput) =>
    this.restService.request<any, PagedResultDto<AssetEventWithNavigationPropertiesDto>>({
      method: 'GET',
      url: `/api/inventory/asset-events`,
      params: { filterText: input.filterText, description: input.description, assetId: input.assetId, eventTypeId: input.eventTypeId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, AssetEventWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/inventory/asset-events/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: AssetEventUpdateDto) =>
    this.restService.request<any, AssetEventDto>({
      method: 'PUT',
      url: `/api/inventory/asset-events/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
